import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dbQuestion from "../../data/data"

export const ProgressBar = () => {
  const formDataDic = useSelector((state) => state.formDataDic);
  const [rate, setRate] = useState(0);
  useEffect(() => {
    const nbrOfQuestion = formDataDic?.formData?.length;
    if (nbrOfQuestion) {
      setRate(nbrOfQuestion);
    }
  }, [formDataDic]);
  return (
    <div className="flex flex-col lg:flex-row ">
      <div className="flex flex-row gap-2 items-center">
        <progress
          className="progress progress-primary w-56"
          value={(rate * 100) / dbQuestion?.length}
          max="100"
        ></progress>
        <p>{Math.round((rate * 100) / dbQuestion?.length)}%</p>
      </div>

      <div className="badge badge-info gap-2 h-fit">
        Il reste <span className="font-bold">{dbQuestion?.length - rate}</span> questions
      </div>
    </div>
  );
};
